import { toast } from 'sonner'
import { AutomationSwitch } from '@/components/automation-switch'
import type { useUpdateInvoice } from '@/features/invoices/mutations'
import { useInvoiceAutomationHistory } from '@/features/invoices/queries'
import { getApiErrorMessage } from '@/lib/api-error'

/** The invoice's Automation switch and who changed it, like a project's or PO's (USA-1640). */
export function InvoiceAutomation({
  invoiceId,
  automationDisabled,
  updateInvoice,
}: {
  invoiceId: string
  automationDisabled: boolean
  updateInvoice: ReturnType<typeof useUpdateInvoice>
}) {
  const history = useInvoiceAutomationHistory(invoiceId)
  return (
    <div className="space-y-3">
      <AutomationSwitch
        id="ap-invoice-automation-toggle"
        description="Supplier emails, AI email analysis, follow-ups, reminders, and payment items for this invoice."
        checked={!automationDisabled}
        onCheckedChange={(enabled) =>
          updateInvoice.mutate(
            { automation_disabled: !enabled },
            { onError: (err) => toast.error(`Failed to update automation: ${getApiErrorMessage(err)}`) },
          )
        }
        disabled={updateInvoice.isPending}
        history={history.data}
        historyLoading={history.isLoading}
        hideLabel
      />
    </div>
  )
}
